
import React from 'react';
import { useTranslationManager } from '@/hooks/useTranslationManager';
import TranslationSearch from './translations/TranslationSearch';
import TranslationTable from './translations/TranslationTable';
import TranslationDialog from './translations/TranslationDialog';

const TranslationManager: React.FC = () => {
  const {
    searchQuery,
    setSearchQuery,
    isDialogOpen,
    setIsDialogOpen,
    isEditMode,
    currentTranslation,
    paginatedTranslations,
    currentPage,
    totalPages,
    handlePageChange,
    handleOpenAddDialog,
    handleOpenEditDialog,
    handleTranslationChange,
    handleSaveTranslation,
    handleDeleteTranslation,
    translate
  } = useTranslationManager();

  return (
    <div className="space-y-4">
      <TranslationSearch 
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onAddClick={handleOpenAddDialog}
        translateFn={translate}
      />

      <TranslationTable 
        translations={paginatedTranslations}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onEdit={handleOpenEditDialog}
        onDelete={handleDeleteTranslation}
        translateFn={translate}
      />

      <TranslationDialog 
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        isEditMode={isEditMode}
        currentTranslation={currentTranslation}
        onTranslationChange={handleTranslationChange}
        onSave={handleSaveTranslation}
        translateFn={translate}
      />
    </div>
  );
};

export default TranslationManager;
